<template>
  <Header />
  <div class="section container">
    <div class="content">
      <div class="full-page-confirmation">
        <p>Order Cancellation Error!</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';

export default {
  name: 'CanceledOrderError',
  components: {
    Header
  },
  mounted() {
    setTimeout(()=>{
      this.$router.push('/home');
    }, 3000);
  }
}
</script>

<style scoped></style>
